import { render, staticRenderFns } from "./buttonspinner.vue?vue&type=template&id=6fedf032&scoped=true"
import script from "./buttonspinner.vue?vue&type=script&lang=js"
export * from "./buttonspinner.vue?vue&type=script&lang=js"
import style0 from "./buttonspinner.vue?vue&type=style&index=0&id=6fedf032&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fedf032",
  null
  
)

export default component.exports